import Swiper from 'swiper';
import {
    A11y,
    Autoplay,
    EffectCoverflow,
    EffectFade,
    EffectFlip,
    Grid,
    Keyboard,
    Navigation,
    Thumbs
} from 'swiper/modules';

// Get every album on the page
const albums = document.querySelectorAll('.bloc-album');

for (let i = 0; i < albums.length; i++) {
    let itemClass = `item-${i}`;
    // Add class for each items
    albums[i].classList.add(itemClass);

    // Get every data-attribute to build config
    let dataAutoScroll = albums[i].querySelector('.swiper').getAttribute('data-auto_scroll');
    let dataAutoScrollSpeed = albums[i].querySelector('.swiper').getAttribute('data-auto_scroll_speed');
    dataAutoScrollSpeed = dataAutoScrollSpeed + '000';
    let dataMargins = albums[i].querySelector('.swiper').getAttribute('data-margins');

    // Declare basic & common config (every sliders got this)
    let config = {

        modules: [A11y, Autoplay, EffectCoverflow, EffectFade, EffectFlip, Grid, Keyboard, Navigation, Thumbs],

        grabCursor: 'true',
        slidesPerView: '1',

        keyboard: {
            enabled: true,
        },

        navigation: {
            nextEl: `.bloc-album.${itemClass} .swiper-button-next`,
            prevEl: `.bloc-album.${itemClass} .swiper-button-prev`,
        },

        a11y: {
            enabled: true,
            firstSlideMessage: "C'est la première diapositive",
            lastSlideMessage: "C'est la dernière diapositive",
            prevSlideMessage: 'Diapositive précédente',
            nextSlideMessage: 'Diapositive suivante',
            slideLabelMessage: '{{index}} / {{slidesLength}}', // default
        },
    }

    // Basic config of gallery sliders (2 sliders for gallery)
    let configGallery = {
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    }

    // Specific config between different sliders
    // -------------------------------------------------------- basic ---- ok
    if (albums[i].classList.contains('bloc-album--basic')) {

        // Configs
        config.effect = 'slide';
        config.loop = true;

        if (dataAutoScroll === 'true') {
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }

        // console.log('Swiper Basic');
    }

    // -------------------------------------------------------- multiples
    else if (albums[i].classList.contains('bloc-album--multiple_slides')) {

        // Configs
        config.effect = 'slide';
        config.spaceBetween = 0;

        if (window.innerWidth < 620) {
            config.slidesPerView = 1;
        } else if (window.innerWidth < 960) {
            config.slidesPerView = 2;
        } else {
            config.slidesPerView = 3;
        }

        if (dataAutoScroll === 'true') {
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }

        if (dataMargins === 'true') {
            if (window.innerWidth < 960) {
                config.spaceBetween = 20;
            } else {
                config.spaceBetween = 30;
            }
        }

        // console.log('Swiper multiple_slides');
    }

    // -------------------------------------------------------- With Grid ---- ok
    else if (albums[i].classList.contains('bloc-album--multiple_rows')) {

        // Configs
        config.effect = 'slide';
        config.slidesPerView = 2;
        config.grid = {rows: 2};

        if (window.innerWidth < 620) {
            config.slidesPerView = 1;
            config.grid = {rows: 2};
        }

        if (dataMargins === 'true') {
            if (window.innerWidth < 960) {
                config.spaceBetween = 20;
            } else {
                config.spaceBetween = 30;
            }
        }

        // console.log('Swiper Module Grid');
    }

    // -------------------------------------------------------- With Coverflow ---- 
    else if (albums[i].classList.contains('bloc-album--coverflow')) {

        // Configs
        config.effect = 'coverflow';
        config.centeredSlides = true;
        config.slidesPerView = 'auto';
        config.initialSlide = 1;

        let coverflowstretch = -30;

        if (window.innerWidth < 620) {
            coverflowstretch = -10;
            config.slidesPerView = 1;
        }

        config.coverflowEffect = {
            rotate: 40,
            stretch: coverflowstretch,
            depth: 150,
            modifier: 1,
            slideShadows: true,
        }

        if (dataAutoScroll === 'true') {
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }

        // console.log('Swiper Module Coverflow');
    }

    // -------------------------------------------------------- With Flip ---- ok
    else if (albums[i].classList.contains('bloc-album--flip')) {

        // Configs
        config.effect = 'flip';
        config.loop = true;

        config.flipEffect = {
            slideShadows: false,
            limitRotation: true,
        }

        if (dataAutoScroll === 'true') {
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }

        // console.log('Swiper Module Flip');
    }

    // -------------------------------------------------------- With Thumbs ---- 
    else if (albums[i].classList.contains('bloc-album--gallery')) {

        config.effect = 'fade';
        config.fadeEffect = {
            crossFade: true,
        }

        if (dataMargins === 'true') {
            configGallery.spaceBetween = 10;
        }

        if (dataAutoScroll === 'true') {
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }

        // console.log('Swiper Module Thumbs / gallery');
    }

    // Call swiper for gallery (bottom slider)
    if (albums[i].classList.contains('bloc-album--gallery')) {

        let swiperGallery = new Swiper(`.bloc-album.${itemClass} .gallery-thumbs`, configGallery);

        config.thumbs = {
            swiper: swiperGallery
        }
    }

    // Call swiper for every sliders with custom config
    let swiperBasic = new Swiper(`.bloc-album.${itemClass} .swiper:not(.gallery-thumbs)`, config);
}

